<template>
    <div>
        <div style="padding-bottom: 3%;" class="adway_subheaders">Step 4 / 4: Now it is time to upload some documents</div>
        <div class="input-field-area">
            <div class="adway_input_filed_headers">Please upload the picture of your driver license (front)</div>
            <div class="input__section">
              <div class="input__context">
                <input class="input-filed" placeholder="eg. image.jpg" type="text" name="driver license" v-model="driverLicenceImage.name" style="width: 100%;">
                <img v-if="driverLicenceImage.name === undefined || driverLicenceImage.name.length === 0" src="./../../../../assets/nonUploadFile.png" alt="no-upload" class="btn-upload-file" @click="driverLicence">
                <img v-if="driverLicenceImage.name !== undefined && driverLicenceImage.name.length > 0" src="./../../../../assets/okgreen.svg" alt="upload" class="btn-upload-file" @click="driverLicence">
              </div>
                <!-- <div id="drivingLicence" v-bind:style="[driverLicenceImage.name !== undefined && driverLicenceImage.name.length > 0 ? cssUpload : cssNonUpload]" class="btn-upload-file" v-bind:class="[driverLicenceImage.name !== undefined  && driverLicenceImage.name.length > 0 ? 'sing-up-document-uploaded-file' : 'sing-up-document-cloud']" @click="driverLicence"></div> -->
                <input type="file" accept='image/*' style="visibility: hidden; width: 0px;" id="driver-licence" @change="previewDriverLicenceImage">
            </div>
        </div>
        <div class="input-field-area">
            <div class="adway_input_filed_headers">Please upload the picture of your insurance</div>
            <div class="input__section">
              <div class="input__context">
                <input class="input-filed" placeholder="eg. image.jpg" type="text" name="insurance" v-model="driverInsuranceImage.name">
                <img v-if="driverInsuranceImage.name === undefined || driverInsuranceImage.name.length === 0" src="./../../../../assets/nonUploadFile.png" alt="no-upload" class="btn-upload-file" @click="insurance">
                <img v-if="driverInsuranceImage.name !== undefined && driverInsuranceImage.name.length > 0" src="./../../../../assets/okgreen.svg" alt="upload" class="btn-upload-file" @click="insurance">
              </div>
              <!-- <div id="driverInsurance" v-bind:style="[driverInsuranceImage.name !== undefined && driverInsuranceImage.name.length > 0 ? cssUpload : cssNonUpload]" class="btn-upload-file" v-bind:class="[driverInsuranceImage.name !== undefined  && driverInsuranceImage.name.length > 0 ? 'sing-up-document-uploaded-file' : 'sing-up-document-cloud']" @click="insurance"></div> -->
              <input type="file" accept='image/*' style="visibility: hidden; width: 0px;" id="insurance" @change="previewDriverInsuranceImage">
            </div>
        </div>
        <div class="input-field-area">
            <div class="adway_input_filed_headers">Please upload the picture of your Uber/Lyft rating</div>
            <div class="input__section">
              <div class="input__context">
                <input class="input-filed" placeholder="eg. image.jpg" type="text" name="rating" v-model="driverRating.name">
                <img v-if="driverRating.name === undefined || driverRating.name.length === 0" src="./../../../../assets/nonUploadFile.png" alt="no-upload" class="btn-upload-file" @click="rating">
                <img v-if="driverRating.name !== undefined && driverRating.name.length > 0" src="./../../../../assets/okgreen.svg" alt="upload" class="btn-upload-file" @click="rating">
              </div>
              <!-- <div id="driverRating" v-bind:style="[driverRating.name !== undefined && driverRating.name.length > 0 ? cssUpload : cssNonUpload]"  class="btn-upload-file sing-up-document-cloud" v-bind:class="[driverRating.name !== undefined  && driverRating.name.length > 0 ? 'sing-up-document-uploaded-file' : 'sing-up-document-cloud']" @click="rating"></div> -->
              <input type="file" accept='image/*' style="visibility: hidden; width: 0px;" id="rating" @change="previewDriverRating">
            </div>
        </div>
        <div class="input-field-area">
            <div class="adway_input_filed_headers">Please upload the picture of the side of your car</div>
            <div class="input__section">
              <div class="input__context">
                <input class="input-filed" placeholder="eg. image.jpg" type="text" name="side picture" v-model="sideImage.name">
                <img v-if="sideImage.name === undefined || sideImage.name.length === 0" src="./../../../../assets/nonUploadFile.png" alt="no-upload" class="btn-upload-file" @click="sidePicture">
                <img v-if="sideImage.name !== undefined && sideImage.name.length > 0" src="./../../../../assets/okgreen.svg" alt="upload" class="btn-upload-file" @click="sidePicture">
              </div>
              <!-- <div id="sideImage" v-bind:style="[sideImage.name !== undefined && sideImage.name.length > 0 ? cssUpload : cssNonUpload]" class="btn-upload-file sing-up-document-cloud" v-bind:class="[sideImage.name !== undefined  && sideImage.name.length > 0 ? 'sing-up-document-uploaded-file' : 'sing-up-document-cloud']" @click="sidePicture"></div> -->
              <input type="file" accept='image/*' style="visibility: hidden; width: 0px;" id="side-picture" @change="previewSideImage">
            </div>
        </div>
        <div class="check-boxs">
            <div>
                <input type="checkbox" name="TermsAndConditions" id="advertiser-ts" v-model="termsAndConditionsCB">
                <label for="advertiser-ts"></label>I agree with <router-link class="external-view" to="/drivertc" style="color: black;">Adway’s Terms and Conditions</router-link>
            </div>
            <div>
                <input type="checkbox" name="adway-notification" id="adway-notification" v-model="notificationCB">
                <label for="adway-notification">I want to receive Adway's campaign notifications</label>
            </div>
        </div>
    </div>
</template>

<script>
import toast from '@utils/toast'
export default {
  name: 'DocumentaionInfo',
  data: function () {
    return {
      termsAndConditionsCB: false,
      notificationCB: this.driver.notification,
      cssNonUpload: {
        backgroundImage: `url(${require('./../../../../assets/nonUploadFile.png')})`
      },
      cssUpload: {
        backgroundImage: `url(${require('./../../../../assets/okgreen.svg')})`
      },
      driverLicenceImage: this.driver.driverLicenceImage === null ? '' : this.driver.driverLicenceImage,
      driverInsuranceImage: this.driver.driverInsuranceImage === null ? '' : this.driver.driverInsuranceImage,
      driverRating: this.driver.driverRating === null ? '' : this.driver.driverRating,
      sideImage: this.driver.sideImage === null ? '' : this.driver.sideImage
    }
  },
  props: {
    driver: Object
  },
  methods: {
    changeSomeDriverSettings () {
      if (this.termsAndConditionsCB) {
        this.driver.driverLicenceImage = this.driverLicenceImage
        this.driver.driverInsuranceImage = this.driverInsuranceImage
        this.driver.driverRating = this.driverRating
        this.driver.sideImage = this.sideImage
        this.driver.notification = this.notificationCB
        this.$emit('changeDriver', this.driver)
      } else {
        toast.termsAndConditionsMissing('Please accept Adway terms and conditions')
      }
    },
    driverLicence () {
      document.getElementById('driver-licence').click()
    },
    insurance () {
      document.getElementById('insurance').click()
    },
    rating () {
      document.getElementById('rating').click()
    },
    sidePicture () {
      document.getElementById('side-picture').click()
    },
    previewDriverLicenceImage (event) {
      this.driverLicenceImage = event.target.files[0]
      // var element = document.getElementById('drivingLicence')
      // element.className = 'image-file-uploaded'
    },
    previewDriverInsuranceImage (event) {
      this.driverInsuranceImage = event.target.files[0]
      // var element = document.getElementById('driverInsurance')
      // element.className = 'image-file-uploaded'
    },
    previewDriverRating (event) {
      this.driverRating = event.target.files[0]
      // var element = document.getElementById('driverRating')
      // element.className = 'image-file-uploaded'
    },
    previewSideImage (event) {
      this.sideImage = event.target.files[0]
      // var element = document.getElementById('sideImage')
      // element.className = 'image-file-uploaded'
    }
  }
}
</script>
